
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect } from "react";
import { logInfo } from "@/utils/logger";
import { Link } from "react-router-dom";

const Documentation = () => {
  useEffect(() => {
    logInfo("Documentation page accessed", "Documentation", {
      timestamp: new Date().toISOString(),
    });
  }, []);

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6">Internal Documentation</h1>
      <div className="text-sm breadcrumbs mb-6">
        <ul className="flex space-x-2">
          <li><Link to="/dashboard" className="text-blue-600 hover:underline">Dashboard</Link></li>
          <li className="before:content-['/'] before:mx-2">Documentation</li>
        </ul>
      </div>

      <Tabs defaultValue="architecture" className="space-y-4">
        <TabsList>
          <TabsTrigger value="architecture">Architecture</TabsTrigger>
          <TabsTrigger value="modules">Modules</TabsTrigger>
        </TabsList>

        <TabsContent value="architecture" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>FraudEye Architecture</CardTitle>
              <CardDescription>
                System architecture and high-level design
              </CardDescription>
            </CardHeader>
            <CardContent className="prose dark:prose-invert max-w-none">
              <iframe 
                src="/internal/docs/ARCHITECTURE.md" 
                className="w-full h-[600px] border rounded"
                title="Architecture Documentation"
              />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="modules" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Module Descriptions</CardTitle>
              <CardDescription>
                Detailed information about system modules
              </CardDescription>
            </CardHeader>
            <CardContent className="prose dark:prose-invert max-w-none">
              <iframe 
                src="/internal/docs/MODULE_DESCRIPTIONS.md" 
                className="w-full h-[600px] border rounded"
                title="Module Documentation"
              />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Documentation;
